import httpClient from '@/_shared/http-client';
import { date } from '@/_shared/utils';

const confirm = async(list = [], listType = 'arrivals') => {
  const url = `/stock_operations/${listType}`;
  const body = {
    list: JSON.stringify(list),
    created_at: date.getIsoString(),
  };
  let results = {};
  await httpClient.post(url, body).then(({ data }) => {
    results = data;
  });
  return results;
}

export const operationService = {
  confirm,
};



// WEBPACK FOOTER //
// ./src/stock/api-services/operationService.js